export default {
    loading: true,
    laodingLocation: true,
    brand: null,
    locations: []
}